import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17.058 8.503"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { transform: "translate(-29.343 -22.588)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    "fill-rule": "evenodd",
    d: "M39.36 23.252a2 2 0 0 0-2.976 0l-7.041 7.84h17.058z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }